import { useNavigate } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { GroupedGrid } from '@/components/GroupedGrid';
import { Column } from '@/components/DataGrid';
import { useClients } from '@/api/hooks';

type Row = Record<string, unknown>;

const columns: Column<Row>[] = [
  { key: 'Source', header: 'Source' },
  { key: 'ClientID', header: 'Client ID' },
  { key: 'ClientSubID', header: 'Client Sub ID' },
  { key: 'ClientType', header: 'Client Type' },
  { key: 'ClientName', header: 'Client Name' },
  { key: 'ContactName', header: 'Contact Name' },
  { key: 'ClientManager', header: 'Client Manager' },
  { key: 'BRCIndustry', header: 'BRC Industry' },
  { key: 'NAICS', header: 'NAICS' },
  { key: 'EntityType', header: 'Entity Type' },
  { key: 'RequestStatus', header: 'Request Status' },
];

export function Clients() {
  const navigate = useNavigate();
  return (
    <GroupedGrid<Row>
      title="Clients"
      columns={columns}
      useData={(g, s) => {
        const q = useClients(g, s);
        return { data: q.data, isFetching: q.isFetching };
      }}
      rowAction={(row) => (
        <button
          title="View / Edit"
          className="text-primary hover:opacity-70"
          onClick={() =>
            navigate(`/clients/${row.ClientID}/${row.ClientSubID}`, {
              state: { opType: row.CompletionDate ? 'Complete' : 'Pending' },
            })
          }
        >
          <Eye className="h-4 w-4" />
        </button>
      )}
    />
  );
}
